/*
 * Admin API helper — small wrapper around fetch that automatically attaches the
 * admin JWT stored in localStorage and normalises errors.
 */
const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "samurai_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

async function request(path, { method = "GET", body, isForm = false } = {}) {
  const headers = {};
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (body && !isForm) headers["Content-Type"] = "application/json";
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: isForm ? body : body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let data;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!res.ok) {
    const detail = data && (data.detail || data.error) ? data.detail || data.error : `HTTP ${res.status}`;
    const err = new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const adminApi = {
  login: (password) => request("/api/admin/login", { method: "POST", body: { password } }),
  me: () => request("/api/admin/me"),
  list: (collection) => request(`/api/admin/${collection}`),
  create: (collection, doc) => request(`/api/admin/${collection}`, { method: "POST", body: doc }),
  update: (collection, id, doc) => request(`/api/admin/${collection}/${id}`, { method: "PATCH", body: doc }),
  remove: (collection, id) => request(`/api/admin/${collection}/${id}`, { method: "DELETE" }),
  reorder: (collection, ids) => request(`/api/admin/${collection}/reorder`, { method: "POST", body: { ids } }),
  getSettings: () => request("/api/admin/settings"),
  updateSettings: (patch) => request("/api/admin/settings", { method: "PATCH", body: patch }),
  upload: async (file) => {
    const form = new FormData();
    form.append("file", file);
    return request("/api/admin/upload", { method: "POST", body: form, isForm: true });
  },
};
